import ExchangeTaskEntry from './ExchangeTaskEntry';
import { ExchangeTaskGroup } from './ExchangeTask.shared';

interface SolicitorExchangeProps {
  campaignId: string;
  group: ExchangeTaskGroup;
}

const SolicitorExchange = ({ campaignId, group }: SolicitorExchangeProps) => (
  <ExchangeTaskEntry
    actionButtonId="completeSolicitorExchangeBtn"
    campaignId={campaignId}
    group={group}
    panelKey="SolicitorExchangePanel"
    title="Solicitor Exchange"
  />
);

export default SolicitorExchange;
